import React, { useState, useEffect } from 'react';
import { Card, CardBody, CardTitle, Form, FormGroup, Label, Input, Button, Alert } from 'reactstrap';
import { getLabProfileById, updateLabProfile, createLabProfile } from '../../services/labProfileApi';
import { connect } from 'react-redux';

const LabProfilePage = ({ currentUser }) => {
  const [labProfile, setLabProfile] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [form, setForm] = useState({ lab_name: '', logo_url: '' });
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (currentUser && currentUser.lab_profile_id) {
      getLabProfileById(currentUser.lab_profile_id)
        .then(res => {
          setLabProfile(res.data);
          setForm({ lab_name: res.data.lab_name || '', logo_url: res.data.logo_url || '' });
        })
        .catch(() => setError('Failed to load lab profile'));
    }
  }, [currentUser]);

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSave = async e => {
    e.preventDefault();
    try {
      const payload = {
        lab_name: form.lab_name,
        logo_url: form.logo_url,
        manager_user_id: currentUser?.id
      };
      const res = await updateLabProfile(currentUser.lab_profile_id, payload);
      setLabProfile(res.data);
      setEditMode(false);
      setSuccess(true);
      setTimeout(() => setSuccess(false), 3000);
    } catch {
      setError('Failed to update lab profile');
    }
  };

  // If Lab user has no lab_profile_id, show create Lab Profile form
  const [createForm, setCreateForm] = useState({ name: '', logo: '' });
  const [createError, setCreateError] = useState(null);
  const [createSuccess, setCreateSuccess] = useState(false);

  const handleCreateChange = e => {
    setCreateForm({ ...createForm, [e.target.name]: e.target.value });
  };

  const handleCreate = async e => {
    e.preventDefault();
    console.log('[LabProfile] handleCreate fired');
    console.log('[LabProfile] Form data:', createForm);
    console.log('[LabProfile] currentUser:', currentUser);
    try {
      const payload = {
        lab_name: createForm.name,
        logo_url: createForm.logo,
        manager_user_id: currentUser?.id
      };
      console.log('[LabProfile] Sending payload to createLabProfile:', payload);
      const res = await createLabProfile(payload);
      console.log('[LabProfile] API response:', res);
      setCreateSuccess(true);
      setCreateError(null);
      setTimeout(() => window.location.reload(), 1500);
    } catch (err) {
      console.error('[LabProfile] Error creating lab profile:', err);
      setCreateError('Failed to create lab profile');
    }
  };

  if (!currentUser || !currentUser.lab_profile_id) {
    return (
      <div className="container mt-4">
        <Card>
          <CardBody>
            <CardTitle tag="h3">Create Lab Profile</CardTitle>
            {createSuccess && <Alert color="success">Lab profile created! Reloading...</Alert>}
            {createError && <Alert color="danger">{createError}</Alert>}
            <Form onSubmit={handleCreate}>
              <FormGroup>
                <Label for="name">Lab Name</Label>
                <Input name="name" id="name" value={createForm.name} onChange={handleCreateChange} required />
              </FormGroup>
              <FormGroup>
                <Label for="logo">Lab Logo URL</Label>
                <Input name="logo" id="logo" value={createForm.logo} onChange={handleCreateChange} />
              </FormGroup>
              <Button color="primary" type="submit">Create</Button>
            </Form>
          </CardBody>
        </Card>
      </div>
    );
  }

  return (
    <div className="container mt-4">
      <Card>
        <CardBody>
          <CardTitle tag="h3">Lab Profile</CardTitle>
          {success && <Alert color="success">Lab profile updated!</Alert>}
          {error && <Alert color="danger">{error}</Alert>}
          {!editMode ? (
            <div>
              <div className="mb-3">
                <strong>Name:</strong> {labProfile?.lab_name}
              </div>
              <div className="mb-3">
                <strong>Logo:</strong> {labProfile?.logo_url ? <img src={labProfile.logo_url} alt="Lab Logo" style={{width:60}} /> : 'None'}
              </div>
              <Button color="primary" onClick={() => setEditMode(true)}>Edit Profile</Button>
            </div>
          ) : null}
        </CardBody>
      </Card>
    </div>
  );
};

const mapStateToProps = state => ({ currentUser: state.auth.currentUser });
export default connect(mapStateToProps)(LabProfilePage);
